module.exports = __webpack_public_path__ + "static/media/studio_agriculture_telehandler_mlt_635_manitou_003.1008cbfe.png";